export function getExternalParams() {
    const params = new URLSearchParams(window.location.search);
    return {
        nit: params.get('nit') || '',
        cmpy: params.get('cmpy') || '',
        reg: params.get('reg') || '',
        teri: params.get('teri') || '',
        phone: params.get('phone') || '',
        referencia: params.get('referencia') || '',
        evt: params.get('evt') || '',
        cash_received: params.get('cash_received') || '',
    };
}
